import React from "react";
import { X } from "lucide-react";

const WorkspaceDialog = ({
  dialogConfig,
  onClose,
  onCancel,
  onConfirm,
  onInputChange,
  activeWorkspaceEnv,
}) => {
  if (!dialogConfig?.isOpen) return null;

  const isScratchTheme =
    activeWorkspaceEnv === "scratch" || activeWorkspaceEnv === "junior";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/75 backdrop-blur-xs p-4 animate-in fade-in duration-200">
      <div
        className={`
          rounded-2xl w-full max-w-sm flex flex-col overflow-hidden animate-in fade-in zoom-in-95 duration-200 border-0
          ${
            isScratchTheme
              ? "bg-white ring-1 ring-neutral-200 shadow-xl text-neutral-900"
              : "bg-[#13151b] ring-1 ring-[#27272a] shadow-[0_20px_50px_rgba(0,0,0,0.8)] text-white"
          }
        `}
      >
        <div className="p-4 flex flex-col gap-2">
          <div className="flex items-start justify-between mb-1">
            <h3
              className="font-bold text-base"
              style={{
                color: isScratchTheme ? "#111827" : "#ffffff",
              }}
            >
              {dialogConfig.title}
            </h3>
            <button
              type="button"
              onClick={onClose}
              className={`w-7 h-7 rounded-full flex items-center justify-center transition-colors border-0 cursor-pointer ${
                isScratchTheme
                  ? "text-neutral-400 hover:bg-neutral-100 hover:text-neutral-700"
                  : "text-neutral-400 hover:bg-white/10 hover:text-white"
              }`}
            >
              <X className="w-4 h-4" />
            </button>
          </div>

          {dialogConfig.message && (
            <p
              className="text-xs leading-relaxed m-0"
              style={{
                color: isScratchTheme ? "#374151" : "#e2e8f0",
              }}
            >
              {dialogConfig.message}
            </p>
          )}

          {dialogConfig.showInput && (
            <div className="mt-2">
              <input
                type="text"
                value={dialogConfig.inputValue}
                onChange={(e) => onInputChange(e.target.value)}
                autoFocus
                className={`
                  w-full rounded-xl px-3.5 py-2.5 text-xs font-medium focus:outline-none transition-colors border-0
                  ${
                    isScratchTheme
                      ? "bg-neutral-50 ring-1 ring-neutral-200 text-neutral-900 focus:ring-2 focus:ring-purple-500"
                      : "bg-[#0a0b0f] ring-1 ring-[#27272a] text-white focus:ring-2 focus:ring-purple-500/50"
                  }
                `}
                placeholder="Enter project name..."
                onKeyDown={(e) => {
                  if (e.key === "Enter") onConfirm();
                  if (e.key === "Escape") onClose();
                }}
              />
            </div>
          )}
        </div>

        <div
          className={`px-4 py-3 flex items-center justify-end gap-2.5 border-0 ${
            isScratchTheme
              ? "bg-neutral-50 border-t border-neutral-100"
              : "bg-[#0c0d12] border-t border-[#222226]"
          }`}
        >
          <button
            type="button"
            onClick={onCancel}
            className="px-3.5 py-2 rounded-xl text-xs font-bold transition-colors cursor-pointer border-0"
            style={{
              color: isScratchTheme ? "#4b5563" : "#cbd5e1",
            }}
          >
            {dialogConfig.cancelText}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className={`px-4 py-2 rounded-xl text-xs font-bold shadow-md shadow-purple-600/30 transition-colors cursor-pointer border-0 ${dialogConfig.confirmClass}`}
          >
            {dialogConfig.confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default WorkspaceDialog;
